import { FC } from 'react'
import { useLoaderData } from 'react-router-dom'
import { PaymentStatus } from '../../components'
import { Global } from '@emotion/react'
import { dynamicStyle } from '../payment-route/payment-route.styled'
import { getCheckoutReturnUrlInLS, getShowResultScreenInLS } from '../../utils/local-storage'
import { dynamicDisplayRedirect } from '../../utils'

export const PaymentStatusRoute: FC = () => {
  const checkoutSession = useLoaderData() as string
  const checkoutReturnUrl = getCheckoutReturnUrlInLS()
  const showResultScreen = getShowResultScreenInLS()

  return (
    <>
      <Global styles={[dynamicStyle(dynamicDisplayRedirect(checkoutReturnUrl, showResultScreen))]} />
      <PaymentStatus checkoutSession={checkoutSession} />
    </>
  )
}
